"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UpOutlined = _interopRequireDefault(require("@ant-design/icons/UpOutlined"));

var _backTop = _interopRequireDefault(require("antd/lib/back-top"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
require("./styles/backToTop.less");

var styles = {
  "root": "meepshop-action-button__backToTop__root"
}; // definition

var _default = /*#__PURE__*/_react["default"].memo(function () {
  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  return /*#__PURE__*/_react["default"].createElement(_backTop["default"], {
    className: styles.root,
    visibilityHeight: typeof window === 'undefined' ? 0 : window.innerHeight
  }, /*#__PURE__*/_react["default"].createElement(_UpOutlined["default"], {
    style: {
      background: colors[0],
      color: colors[3],
      boxShadow: "0 2px 10px 0 ".concat(colors[3])
    }
  }));
});

exports["default"] = _default;